import Swiper from 'swiper/bundle'

const $ = jQuery

export default function TestimonialsSlider () {
  const sliderWrappers = document.querySelectorAll('.mtt-testimonials-slider')

  if (sliderWrappers.length) {
    for (let i = 0; i < sliderWrappers.length; i++) {
      const wrapper = sliderWrappers[i]

      const slider = new Slider(wrapper)
    }
  }
}

class Slider {
  constructor (wrapper) {
    this.wrapper = wrapper

    this.addSlider()
  }

  addSlider () {
    const swiper = new Swiper(this.wrapper.querySelector('.swiper-container'), {
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      pagination: {
        el: this.wrapper.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: this.wrapper.querySelector('.slider-button--next'),
        prevEl: this.wrapper.querySelector('.slider-button--prev')
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        580: {
          slidesPerView: 1,
          spaceBetween: 40
        },
        850: {
          slidesPerView: 2,
          spaceBetween: 40
        },
        1400: {
          slidesPerView: 2,
          spaceBetween: 60
        }
      }
    })
  }
}
